import { render } from "./StudentAchievements.vue?vue&type=template&id=1f74939d"
import script from "./StudentAchievements.vue?vue&type=script&lang=js"
export * from "./StudentAchievements.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__